<template>
  <div>
    <div class="body-2 mb-2">{{ label }}</div>
    <v-row align="center">
      <v-col cols="8" md="6">
        <v-text-field
          v-model="newEmail"
          label="Correo"
          :error-messages="errorMessage"
          @keyup.enter="add"
        />
      </v-col>
      <v-col cols="4" md="3">
        <v-btn :disabled="!isValidNewEmail" @click="add">Agregar</v-btn>
      </v-col>
    </v-row>
    <v-chip
      v-for="email in value"
      :key="email"
      class="mr-2 mb-2"
      close
      @click:close="remove(email)"
    >{{ email }}</v-chip>
    <div v-if="!value.length" class="body-2 grey--text">
      Sin destinatarios cargados.
    </div>
  </div>
</template>

<script>
"use strict";

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export default {
  name: "email-list",
  props: {
    value: { type: Array, default: () => [] },
    label: { type: String, default: "Destinatarios" }
  },
  data() {
    return { newEmail: null, errorMessage: null };
  },
  computed: {
    isValidNewEmail() {
      const email = (this.newEmail || "").trim().toLowerCase();
      return EMAIL_PATTERN.test(email) && this.value.indexOf(email) === -1;
    }
  },
  methods: {
    add() {
      const email = (this.newEmail || "").trim().toLowerCase();
      if (!EMAIL_PATTERN.test(email)) {
        this.errorMessage = "Correo inválido";
        return;
      }
      if (this.value.indexOf(email) !== -1) {
        this.errorMessage = "Ya está en la lista";
        return;
      }
      this.errorMessage = null;
      // Se emite una lista nueva en vez de mutar la que llego por prop: la
      // empresa se guarda entera al final y Vue tiene que ver el cambio.
      this.$emit("input", this.value.concat(email));
      this.newEmail = null;
    },
    remove(email) {
      this.$emit("input", this.value.filter(e => e !== email));
    }
  }
};
</script>
